/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'

/** Utilities */
import ContractMaintenancetab from './ContractMaintenance.tab'

/** Common Components */
import ToolbarButtons from '../../../../components/toolbarButtons/ToolbarButtons'
import { useNavigate } from 'react-router-dom'
import Label from '../../../../components/finalForms/ui/label/Label'
import CustomCenterModel from '../../../../components/ui/customCenterModel/CustomCenterModel'
import { AppIcons } from '../../../../data/appIcons'
import FormInputFields from '../../../../components/finalForms/formFields/FormInputFields'
import Buttons from '../../../../components/ui/button/Buttons'
import ToastService from '../../../../services/toastService/ToastService'

/** Configuration files */
import { contractToolbarConfig, contractToolbarDeleteBtnConfig } from './Contract.toolbar.config'

/** RTK Query */
import { useGetAllContractsListMutation, useUpdateContractMutation, useUpdateContractNameMutation } from '../../../../app/services/contractAPI'
import { ContractProvider } from '../../../../utils/context/ContractContext'

const ContractMaintenance = () => {

  const url = window.location.search;
  const contractId = new URLSearchParams(url).get("contract");
  const navigate = useNavigate();
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [contractName, setContractName] = useState('');
  const [contractData, setContractData] = useState(null);
  const [isSaveClicked, setIsSaveClicked] = useState(false);
  
  const req = {
    pagination: {
      pageNumber: 1,
      pageSize: 99999,
    },
    plContractKey: contractId,
    plClientKey: 0,
    pbIncludeInactive : true,
  }

  const [getAllContractsList, {
    isSuccess: isAllContractsListFetched,
    data: AllAllContractsListData
  }] = useGetAllContractsListMutation();

  const [updateContractName, {
    isSuccess: isUpdateContractNamesuccess,
    data: updateContractNameData,
  },] = useUpdateContractNameMutation();

  const [updateContract, {
    isSuccess: isUpdateContract,
    data: updateContractData,
  },] = useUpdateContractMutation();

  useEffect(() => {
    if (contractId) {
      getAllContractsList(req);
    }
  }, [contractId]);

  useEffect(() => {
    if (isAllContractsListFetched && AllAllContractsListData) {
      setContractData(AllAllContractsListData?.dataSource[0]);
    }
  }, [isAllContractsListFetched, AllAllContractsListData]);

  useEffect(() => {
    if (isUpdateContractNamesuccess && updateContractNameData) {
      if (updateContractNameData) {
        ToastService.success(updateContractNameData?.errorMessage);
        handleCloseModel();
        getAllContractsList(req);
      }
      else {
        ToastService.error("Something went wrong");
      }
    }
  }, [isUpdateContractNamesuccess, updateContractNameData]);

  const handleRenameClick = () => {
    setIsModelOpen(true);
    setContractName(contractData?.contractName);
  };

  const handaleNameChange = (dataField, value) => {
    setContractName(value);
  }

  const handleCloseModel = () => {
    setIsModelOpen(!isModelOpen);
  };

  const handleCloseClick = () => {
    navigate(`/Contracts`);
  };

  const handaleSave = () => {
    const req = {
      plContractKey: contractId,
      sContractName: contractName,
    };
    updateContractName(req);
  }

  const handleSaveClick = (data) => {
    debugger
    setIsSaveClicked(true);
    if(data?.dtOriginalTerminationDate < data?.dtDateEffective){
      ToastService.error("Original Termination Date cannot be less than Effective Date");
      return;
    }
    if(data?.dtDateTermination < data?.dtDateEffective){
      ToastService.error("Termination Date cannot be less than Effective Date");
      return;
    }
    if(data?.bCostsPerDepartment && data?.sPurchaseOrder.trim() === ''){
      ToastService.error("Purchase Order is required when Costs Per Department is enabled");
      return;
    }
    if (data?.billTypeEmail && (data?.sBillEmail ?? '').trim() === '') {
      ToastService.error("Billing Email is required when Bill Type is Email");
      return;
    }
    
   if(data?.bSharedRisk && data?.nSharedRiskPercentage <= 0){
      ToastService.error("Shared Risk Details are required when Shared Risk is enabled");
      return;
    }

    const lBillType = data?.billTypeAddress && data?.billTypeEmail ? 3 : data?.billTypeAddress ? 1 : data?.billTypeEmail ? 2 : 0;
  
    const dtpDateEffective = new Date(data?.dtDateEffective);
    const lBillDay = dtpDateEffective.getDate();

    const request = {
      plContractKey: contractId,
      plSalesRepKey: data?.lSalesRepKey,
      plPaymentTermsKey: data?.lPaymentTermsKey,
      psContractName1: data?.sContractName1,
      psContractName2: data?.sContractName2,
      pdtDateEffective: data?.dtDateEffective,
      pdtDateTermination: data?.dtDateTermination,
      pAmtTotal: data?.dblAmtTotal,
      pAmtInvoiced: data?.dblAmtInvoiced,
      psContractAddr1: data?.sContractAddr1,
      psContractAddr2: data?.sContractAddr2,
      psContractCity: data?.sContractCity,
      psContractState: data?.sContractState,
      psContractZip: data?.sContractZip,
      psContractPhoneNumber: data?.sContractPhoneNumber,
      psPurchaseOrder: data?.sPurchaseOrder,
      plInstallmentTypeID: data?.lInstallmentTypeID,
      psBillEmail: data?.sBillEmail,
      psBillEmailName: data?.sBillEmailName,
      plBillType: lBillType,
      plBillDay: lBillDay,
      plSalesTaxKey: data?.lSalesTaxKey,
      pdtOriginalTerminationDate: data?.dtOriginalTerminationDate,
      plContractTypeKey: data?.lContractTypeKey,
      pbServicePlan: data?.bServicePlan,
      plServicePlanTermKey: data?.lServicePlanTermKey && data?.lServicePlanTermKey === "object" ? data?.lServicePlanTermKey.value : data?.lServicePlanTermKey,
      pbTaxExempt: data?.bTaxExempt,
      psContractShippingName1: data?.sContractShippingName1,
      psContractShippingName2: data?.sContractShippingName2,
      psContractShippingAddr1: data?.sContractShippingAddr1,
      psContractShippingAddr2: data?.sContractShippingAddr2,
      psContractShippingCity: data?.sContractShippingCity,
      psContractShippingState: data?.sContractShippingState,
      plContractShippingZip: data?.sContractShippingZip,
      psContractShippingPhoneNumber: data?.sContractShippingPhoneNumber,
      psContractShippingFaxNumber: data?.sContractShippingFaxNumber,
      pbShippingSameAsBilling: data?.bShippingSameAsBilling,
      pbShowShippingAddressOnInvoice: data?.bShowShippingAddressOnInvoice,
      pbSharedRisk: data?.bSharedRisk,
      pnSharedRiskPercentage: data?.nSharedRiskPercentage,
      pdtSharedRiskStartDate: data?.dtSharedRiskStartDate,
      pbManualSchedule: data?.bManualSchedule,
      pbCostsPerDepartment: data?.bCostsPerDepartment,
      pbUnlimitedProducts: data?.bUnlimitedProducts,
      pbShowConsumptionOnPortal: data?.pbShowConsumptionOnPortal,
    };
    console.log(request);
  };

  const handleActionClick = (action) => {
    switch (action) {
      case "SAVE":
             handleSaveClick();
        break;
      case "RENAME":
        handleRenameClick();
        break;
      case "CLOSE":
        handleCloseClick();
        break;
      case "DELETE":
        //    handleCloseClick();
        break;
      default:
        break;
    }
  };
  return (
    <div>
      <div className="row">
        <div className="col-12">
          <div className='top-action'>
            <div className='left-action-btns'>
              <ToolbarButtons
                toolbarConfiguration={contractToolbarConfig}
                onActionClick={handleActionClick}
              />
            </div>
            <div className='right-info-sec'>
              <Label labelName={`Contract :   ${contractData?.contractName ? contractData?.contractName : ''} `}></Label>
              <Label labelName={`Client :   ${contractData?.clientName ? contractData?.clientName : ''} `}></Label>
            </div>
          </div>
        </div>

      </div>
      <div className='contarct-maintenance-page mt-2'>
        <ContractProvider>
          <ContractMaintenancetab
          isClicked={isSaveClicked}
          onSaveClick={handleSaveClick}
           />
        </ContractProvider>

      </div>
      <div className="leftbottomsection-deletebtn">
        <ToolbarButtons
          toolbarConfiguration={contractToolbarDeleteBtnConfig}
          onActionClick={handleActionClick}
        />
      </div>
      <CustomCenterModel
        isOpen={isModelOpen}
        useCustomBg={true}
        modalTitle={"Edit Contract Name"}
        contentClass="content-35"
        onClose={handleCloseModel}
        modalTitleIcon={AppIcons.editIcon}
      >
        <FormInputFields
          dataField="contractName"
          value={contractName}
          labelName="Contract Name"
          isRequired={true}
          type="text"
          name="Enter Contract Name"
          onChange={handaleNameChange}
          error={contractName === '' ? 'Contract Name is required' : ''}
        />
        <div className="d-flex justify-content-center button-submit mt-3">
          <Buttons
            buttonText="Save"
            buttonTypeClassName="btn blue-btn w-full"
            onClick={handaleSave}
          // isDisable={!isEditContract}
          />
          <Buttons
            buttonText="Cancel"
            buttonTypeClassName="btn secondary-btn ml-4"
            onClick={handleCloseModel}
          />
        </div>
      </CustomCenterModel>

    </div>

  )
}
export default ContractMaintenance
